import { errorMaxJobHoursMessage, errorMinJobHoursMessage } from '../../../../constants/text';

export default {
  numbers: 'The field "{0}" must be a valid number',
  requiredIdField: 'This field is required',
  email: 'The field "{0}" must be a valid email address',
  required: 'This field is required',
  requiredCheckbox: 'This field is required',
  date: 'The field "{0}" must be a valid date ({1})',
  minLength: 'The field "{0}" length must be greater than {1}',
  maxLength: 'The field "{0}" length must be lower than {1}',
  length: 'The field "{0}" length must be {1}',
  password: 'The password must be at least 8 characters with 1 Uppercase and 1 Number',
  zipcode: 'Please, enter a valid zip code',
  cvc: 'Please, enter a valid CVV code',
  minJobHours: errorMinJobHoursMessage,
  maxJobHours: errorMaxJobHoursMessage,
  isUrl: 'Not valid',
  maxValue: 'Max value is {1}',
  minValue: 'Min value is {1}'
};



// WEBPACK FOOTER //
// ./src/components/common/forms/Validator/defaultMessages.js